// @ts-check

/**
 * @type {import('.').ThemeFactory}
 */
export const themeFactory = (options) => {
  return {
    ...options,
    copyright: options.copyright || 'Agency',
  };
};
